<div
    *ngIf="section"
    class="container links-section d-xl-none"
    [ngClass]="{ 'footer-container': colors.isCustomFooter }"
    [ngStyle]="{ 'background-color': colors.footerColor }"
>
    <div class="content">
        <div class="title">{{ section.title }}</div>
        <a
            *ngFor="let link of section.links"
            [href]="link.url"
            rel="noopener noreferrer"
            class="link gtm-premium-collection-footer-link selenium-premium-collection-footer-link"
            [attr.data-gtmlabel]="link.title"
            [attr.aria-label]="'Follow' + link.title"
            [ngStyle]="{ 'background-color': colors.secondaryButtonColor }"
        >
            {{ link.title }}
            <em class="fas fa-external-link-alt"></em>
        </a>
        <div class="description" innerHTML="{{ section.description }}"></div>
    </div>
</div>
<div
    *ngIf="section"
    class="links-section d-none d-xl-block background-holder"
    [ngStyle]="imgBackgroundStyle"
>
    <div class="container" [ngClass]="{ 'footer-container': colors.isCustomFooter }">
        <div class="content">
            <div class="title">{{ section.title }}</div>
            <a
                *ngFor="let link of section.links"
                [href]="link.url"
                target="_blank"
                rel="noopener noreferrer"
                class="link gtm-premium-collection-footer-link selenium-premium-collection-footer-link"
                [attr.data-gtmlabel]="link.title"
                [attr.aria-label]="'Follow' + link.title"
                [ngStyle]="{
                    'background-color': colors.secondaryButtonColor,
                }"
            >
                {{ link.title }}
                <em class="fas fa-external-link-alt"></em>
            </a>
            <div class="description" innerHTML="{{ section.description }}"></div>
        </div>
    </div>
</div>
